module.exports = __webpack_public_path__ + "media/reference_check/images/not_interested_page-41068136d5f3e901182c4be21da87269.svg";